// ===========================================
// System Emails Page
// Dedicated page for managing system email templates
// ===========================================

import { Alert, Box } from '@mui/material';
import { usePermissions } from '../../hooks/usePermissions';
import PageHeader from '../../components/common/PageHeader';
import TemplateManagerCard from '../../components/admin/settings/TemplateManagerCard';

// ===========================================
// MAIN COMPONENT
// ===========================================

export default function SystemEmailsPage() {
  const { can } = usePermissions();
  const canWrite = can('communications_settings', 'write');

  return (
    <Box>
      <PageHeader
        title="System Emails"
        subtitle="Control which email notifications are sent to parents, teachers, and students"
        breadcrumbs={[
          { label: 'Admin', path: '/admin' },
          { label: 'System Emails' },
        ]}
      />

      {!canWrite && (
        <Alert severity="info" sx={{ mb: 2 }}>
          You can view these settings. Changing them needs the Communications Settings permission.
        </Alert>
      )}

      <TemplateManagerCard readOnly={!canWrite} />
    </Box>
  );
}
